import {
  AppWindow,
  BotMessageSquare,
  Earth,
  Globe,
  Languages,
  Mail,
  MessageCircle,
  MessagesSquare,
  MessageSquareText,
  Mic,
  Monitor,
  Phone,
  Video,
  Webhook,
} from 'lucide-react';
import { createLucideIcon } from '../createLucideIcon';

// Communication / channel icons.
// GAP: MUI Chat is filled; Lucide is outline-only, so Chat and ChatBubbleOutline
// collapse to the same glyph.
export const ChatIcon = /* #__PURE__ */ createLucideIcon('Chat', MessageCircle);
export const ChatBubbleOutlineIcon = /* #__PURE__ */ createLucideIcon('ChatBubbleOutline', MessageCircle);
export const ForumIcon = /* #__PURE__ */ createLucideIcon('Forum', MessagesSquare);
export const SmsIcon = /* #__PURE__ */ createLucideIcon('Sms', MessageSquareText);
export const AssistantIcon = /* #__PURE__ */ createLucideIcon('Assistant', BotMessageSquare);
export const EmailIcon = /* #__PURE__ */ createLucideIcon('Email', Mail);
export const KioskIcon = /* #__PURE__ */ createLucideIcon('Kiosk', Monitor);
export const PhoneIcon = /* #__PURE__ */ createLucideIcon('Phone', Phone);
export const MicIcon = /* #__PURE__ */ createLucideIcon('Mic', Mic);
export const MicNoneOutlinedIcon = /* #__PURE__ */ createLucideIcon('MicNoneOutlined', Mic);
export const VideocamIcon = /* #__PURE__ */ createLucideIcon('Videocam', Video);
export const LanguageIcon = /* #__PURE__ */ createLucideIcon('Language', Globe);
export const PublicIcon = /* #__PURE__ */ createLucideIcon('Public', Earth);
export const TranslateIcon = /* #__PURE__ */ createLucideIcon('Translate', Languages);
export const WebIcon = /* #__PURE__ */ createLucideIcon('Web', AppWindow);
export const WebhookOutlinedIcon = /* #__PURE__ */ createLucideIcon('WebhookOutlined', Webhook);
// GAP: Lucide ships no brand icons — see `_sets/brand.tsx` (`WhatsAppIcon`).
